import {
  Component,
  OnInit,
  HostListener,
  Input,
  ViewChild,
  Inject,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OwlOptions, CarouselComponent } from 'ngx-owl-carousel-o';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import * as CryptoJS from 'crypto-js';
import moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Swal from 'sweetalert2';

@Component({
  selector: 'app-customer-bottom-banner',
  templateUrl: './customer-bottom-banner.component.html',
  styleUrls: ['./customer-bottom-banner.component.scss'],
})
export class CustomerBottomBannerComponent implements OnInit {
  @ViewChild('owlElement') owlElement: CarouselComponent;

  @Input() shop_template: string = 'default';

  get_bottom_banner_response: any = [{ image: '' }];
  get_bottom_banner_response_latest: any = [];
  get_bottom_banner_response_filter: any = [];
  imgUrl = environment.ImageUrl;
  client_id: any = 0;
  get_bottom_banner_response_length: any = 0;
  encrypted_client_id: string = '';
  enc_app_user_id: string = '';
  isMarketplace: boolean = false;
  detail: any = {};
  baseUrlImage = environment.ImageUrl;
  isLogin: any = 0;
  appUserId: any = 0;

  bottomImagesForm: FormGroup;
  // Editor = ClassicEditor;
  EditorData: any = ``;
  EditorConfig = {
    toolbar: {
      items: [
        'heading',
        '|',
        'bold',
        'italic',
        'link',
        '|',
        'bulletedList',
        'numberedList',
        '|',
        // 'insertTable',
        // 'imageUpload',
        // '|',
        'undo',
        'redo',
      ],
    },
  };
  ckEditorText: string = '';

  blogImageUrl: string = '';
  blogPathImage: any = null;
  blogImageSelected: any = null;
  categories: any = ['SG News', 'Promotions', 'Funny', 'Business'];
  category: string = this.categories[0];
  private modalRef: any;

  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private local: LocalServiceService,
    private fb: FormBuilder,
    @Inject("WINDOW") private window: any,
  ) {
    this.route.params.subscribe((res: any) => {
      if (Object.keys(res).length === 0) {
        return;
      }
      if (res.id) {
        const bytes = CryptoJS.AES.decrypt(res.id.trim(), 'shop-web-links');
        const originalText = bytes.toString(CryptoJS.enc.Utf8);
        const splitText = originalText.split('_');
        if (splitText.length == 2 && splitText.includes('normal')) {

          this.client_id = splitText[1];
          this.encrypted_client_id = encodeURIComponent(res.id.trim());
        } else if (splitText.length == 3 && splitText.includes('referral')) {

          this.client_id = splitText[1];
          this.enc_app_user_id = splitText[2];
          this.encrypted_client_id = encodeURIComponent(res.id.trim());
        } else {
        }
      }
    });
  }

  defaultOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    autoplay: false,
    navSpeed: 700,
    smartSpeed: 4500,
    autoplayHoverPause: true,
    slideTransition: 'linear',
    navText: [
      '<i id="prev-btn" class="prev-btn"></i>',
      '<i id="next-btn" class="next-btn"></i>',
    ],
    items: 3,
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 2,
      },
      740: {
        items: 3,
      },
      // 940: {
      //   items: 4,
      // },
    },
    nav: true,
  };

  mobileOptions: OwlOptions = {
    ...this.defaultOptions,
    nav: false,
    dots: true,
  };

  customOptions: OwlOptions = this.defaultOptions;

  ngOnInit(): void {
    const checkUrl = window.location.href;
    if (checkUrl.includes('marketplace')) {
      this.isMarketplace = true;
    }

    const getUser = this.local.getUser();

    if (getUser) {
      this.appUserId = getUser.id;
    }

    getUser ? (this.isLogin = 1) : 0;

    this.get_bottom_banner();
    this.updateOwlOptions();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.updateOwlOptions();
  }

  updateOwlOptions() {
    if (this.window.innerWidth < 600) {
      this.customOptions = this.mobileOptions;
    } else {
      this.customOptions = this.defaultOptions;
    }
  }

  get_bottom_banner() {
    const clientId = this.client_id;
    if (clientId)
      this.auth.get_bottom_banner({
        adminId: clientId,
        isAdmin: this.isMarketplace
      }).subscribe(
        (response: any) => {
          if (response.body && Array.isArray(response.body)) {
            this.get_bottom_banner_response = response.body;
            this.get_bottom_banner_response_length = response.body.length;
            this.get_bottom_banner_response_latest = response.body;
            this.get_bottom_banner_response_latest.sort(
              (a: any, b: any) => b.id - a.id
            );
            this.get_bottom_banner_response.sort(
              (a: any, b: any) =>
                b.bottomBannerLikes.length - a.bottomBannerLikes.length
            );

            if (this.isMarketplace && this.category) {
              this.get_bottom_banner_response_filter =
                this.get_bottom_banner_response.filter(
                  (row: any) => row.category == this.category
                );
            } else {
              this.get_bottom_banner_response_filter =
                this.get_bottom_banner_response;
            }
          }
        },
        (e) => {
          this.toastr.error(e.error.message);
        }
      );
  }

  convertDate(value: number) {
    return moment.unix(value).format('MMMM D, YYYY');
  }

  checkShopAndEmpty() {
    return (
      this.window.location.href.includes('/mobile/') &&
      this.get_bottom_banner_response_length < 1
    );
  }

  navigateToUrl(url: string): void {
    this.window.open(url, '_blank');
  }

  openDetailBlog(modal: any, item: any) {
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, {
      size: 'md',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'modal-blog',
    });

    this.detail = item;
  }

  onEditorChange(event: any) {
    this.ckEditorText = event.editor.getData();
  }

  openModalBlogForm(modal: any, item: any = { text: '' }) {
    if (this.isLogin == 0) {
      return this.toastr.error('Please Login First !');
    }
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static',
    });

    this.ckEditorText = item?.text;
    this.blogImageUrl =
      item?.image != null ? `${this.baseUrlImage}${item.image}` : '';
    this.bottomImagesForm = this.fb.group({
      id: [item?.id, []],
      banner: ['', [Validators.required]],
      title: [item?.title, [Validators.required]],
      author: [item?.author, [Validators.required]],
      category: [item?.category, [Validators.required]],
    });
  }

  editBlog(modal: any, item: any) {
    this.openModalBlogForm(modal, item);
  }

  onBottomBannerSelected(files: any, event: any) {
    this.blogImageUrl = '';
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    const file = event.target.files;
    if (file && file[0]) {
      if (file[0].size > 2097152) {
        this.toastr.error('Max File size must be Less than 2MB!');
        return;
      }

      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.blogImageUrl = event.target.result;
      };
      reader.readAsDataURL(file[0]);
    }

    this.blogPathImage = files;
    this.blogImageSelected = <File>files[0];

  }
  addBottomBanner() {
    // alert()
    // this.submitted = true;

    const id = this.bottomImagesForm.value.id;

    if (this.bottomImagesForm.invalid && id == null) {
      return;
    }

    let formData = new FormData();
    formData.append('title', this.bottomImagesForm.value.title);
    formData.append('category', this.bottomImagesForm.value.category);
    formData.append('text', this.ckEditorText);
    // formData.append('url', this.bottomImagesForm.value.url);
    formData.append('author', this.bottomImagesForm.value.author);
    formData.append('image', this.blogImageSelected);
    formData.append('adminId', '0');
    formData.append('isAdmin', '1');

    let method = 'add_bottom_banner';
    if (id != null) {
      method = 'edit_bottom_banner';
      formData.append('bottomBannerId', id);
    }

    this.local.alertLoading({});

    this.auth[method](formData).subscribe(
      (response: any) => {
        Swal.close();

        this.modalService.dismissAll();
        this.get_bottom_banner();
        // this.bottom_banner_image_url_show = 0;
        this.toastr.success(response.message);
      },
      (e) => {
        this.toastr.error(e.error.message);
        Swal.close();
      }
    );
  }

  deleteBlog(id: number) {
    this.local.alertConfirm({}).then((resp: any) => {
      if (resp.isConfirmed) {
        this.auth.delete_bottom_banner({ bottomBannerId: id }).subscribe(
          (response: any) => {
            this.modalService.dismissAll();
            this.get_bottom_banner();
            // this.bottom_banner_image_url_show = 0;
            this.toastr.success(response.message);
          },
          (e) => {
            this.toastr.error(e.error.message);
          }
        );
      }
    });
  }

  hasChecked(data: any) {
    return data.filter((row: any) => row.userId == this.appUserId).length > 0;
  }

  likeHandle(bottomBannerId: number, data: any) {
    if (this.isLogin == 0) {
      return this.toastr.error('Please Login First !');
    }
    const payload = {
      userId: this.appUserId,
      bottomBannerId: bottomBannerId,
    };

    if (this.hasChecked(data.bottomBannerLikes))
      data.bottomBannerLikes = data.bottomBannerLikes.filter(
        (row: any) => row.userId != this.appUserId
      );
    else data.bottomBannerLikes = [...data.bottomBannerLikes, payload];

    this.auth.likes_bottom_banner(payload).subscribe(() => {
      this.get_bottom_banner();
    });
  }

  filterByCategory(value: string) {
    this.category = value;
    if (this.isMarketplace) {
      this.get_bottom_banner_response_filter =
        this.get_bottom_banner_response.filter(
          (row: any) => row.category == this.category
        );
      this.get_bottom_banner_response_latest =
        this.get_bottom_banner_response.filter(
          (row: any) => row.category == this.category
        );
    } else {
      this.get_bottom_banner_response_filter = this.get_bottom_banner_response;
      this.get_bottom_banner_response_latest = this.get_bottom_banner_response;
    }
  }

  prev() {
    const nextButton = document.querySelector('.prev-btn') as HTMLElement;
    if (nextButton) {
      nextButton.click();
    }
  }

  next() {
    const nextButton = document.querySelector('.next-btn') as HTMLElement;
    if (nextButton) {
      nextButton.click();
    }
  }
}
